import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin");
  }, [user, loading, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-emerald-950">
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?auto=format&fit=crop&q=85&w=1000" alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative flex items-center gap-2.5">
          <span className="grid place-items-center w-10 h-10 rounded-md bg-white/10"><Crown className="w-5 h-5" style={{ color: "#C59B27" }} /></span>
          <span className="font-serif text-lg text-white">Emerald Crown</span>
        </div>
        <div className="relative">
          <h2 className="text-3xl font-serif text-white leading-tight">Lead Management System</h2>
          <p className="mt-3 text-emerald-100/70 max-w-sm">Every enquiry, captured, tracked and followed up — so no opportunity slips through.</p>
        </div>
        <div />
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm bg-white rounded-2xl p-8 shadow-2xl">
          <span className="grid place-items-center w-12 h-12 rounded-xl bg-emerald-50 mx-auto"><Lock className="w-6 h-6 text-emerald-800" /></span>
          <h1 className="mt-5 text-2xl font-serif text-center text-slate-900">Admin access</h1>
          <p className="mt-2 text-sm text-slate-500 text-center">Secure sign-in for authorised Emerald Crown staff only.</p>
          <Button onClick={signIn} data-testid="admin-google-signin" className="mt-7 w-full bg-emerald-900 hover:bg-emerald-800 text-white rounded-full h-12">
            Sign in with Google
          </Button>
          <p className="mt-4 text-xs text-slate-400 text-center">Access is restricted to approved accounts. Lead data is never exposed publicly.</p>
        </div>
      </div>
    </div>
  );
}
